export default class BillingCustomerAudit {
  id: string;

  instance: string;

  amount: number;

  contract: string;

  contractExternalId: string;

  currentContractExternalId: string;

  status: string;

  performsBilling: boolean;

  performsBillingAtCompetence: boolean;

  invoiceStatus: string;

  billedValue: number;

  pastMonthBilledAmount: number;

  pastMonthBilledValue: number;

  currentMonthAmount: number;

  erpValue: number;

  erpInvoiceNumber: string;

  netValue: number;

  detailValue: number;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.instance = obj.instance || '';
    this.amount = obj.amount || null;
    this.contract = obj.contract || '';
    this.contractExternalId = obj.contractExternalId || '';
    this.status = obj.contractExternalId ? (obj.status || '') : null;
    this.performsBilling = obj.contractExternalId ? obj.performsBilling : null;
    this.performsBillingAtCompetence = obj.contractExternalId
      ? obj.performsBillingAtCompetence : null;
    this.invoiceStatus = obj.invoiceStatus || '';
    this.billedValue = obj.billedValue || null;
    this.pastMonthBilledAmount = obj.pastMonthBilledAmount || null;
    this.pastMonthBilledValue = obj.pastMonthBilledValue || null;
    this.currentMonthAmount = obj.currentMonthAmount || null;
    this.erpValue = obj.contractExternalId ? (obj.erpValue || null) : null;
    this.erpInvoiceNumber = obj.contractExternalId ? (obj.erpInvoiceNumber || '') : null;
    this.netValue = obj.contractExternalId ? (obj.netValue || null) : null;
    this.detailValue = obj.contractExternalId ? (obj.detailValue || null) : null;
    this.currentContractExternalId = obj.currentContractExternalId || '';
  }
}
